const padding = {
  xs: 2,
  s: 4,
  m: 8,
  l: 16
};
export default padding;
//# sourceMappingURL=spacing.js.map